import { render, staticRenderFns } from "./LanguageMarketing.vue?vue&type=template&id=2b2140a4&"
import script from "./LanguageMarketing.vue?vue&type=script&lang=js&"
export * from "./LanguageMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports